import React from 'react'
import CalendarDatePicker from "ui/components/comp-507";


const UnreviewedHoursByJCFilters = ({ filters, setFilters }) => {

    const handleDateRangeChange = (dateRange) => {
        const { date, ...restFilters } = filters;
        setFilters({
            ...restFilters,
            startDate: dateRange?.from || undefined,
            endDate: dateRange?.to || undefined,
        });
    };

    const dateRange = {
        from: filters?.startDate,
        to: filters?.endDate,
    };
    return (
        <CalendarDatePicker
            date={dateRange}
            setDate={handleDateRangeChange}
            placeholder="Pick a date range"
        />
    )
}

export default UnreviewedHoursByJCFilters